var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13081",
    "data-name": "Group 13081",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.604,
    height: 22,
    viewBox: "0 0 16.604 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5014",
    "data-name": "Rectangle 5014",
    width: 16.604,
    height: 22,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12762",
    "data-name": "Group 12762",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45358",
    "data-name": "Path 45358",
    d: "M1.64,0H15c.115.035.233.065.346.106A1.95,1.95,0,0,1,16.6,2.012q-.021,9.3-.007,18.6c0,.122,0,.244-.009.365a1,1,0,0,1-1.09,1.015,1.4,1.4,0,0,1-.778-.38q-2.8-2.387-5.611-4.771a1.32,1.32,0,0,0-.44-.253,1.212,1.212,0,0,0-1.213.342q-2.731,2.34-5.482,4.657a2.024,2.024,0,0,1-.526.324.958.958,0,0,1-1.33-.567,2.219,2.219,0,0,1-.113-.755Q0,12.62,0,4.652c0-.909,0-1.818,0-2.728A1.861,1.861,0,0,1,1.2.153,4.209,4.209,0,0,1,1.64,0",
    transform: "translate(0)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkBlack);
export default __webpack_public_path__ + "static/media/bookmark_black.b8d663659d76bb81bc35fb2f408c49b6.svg";
export { ForwardRef as ReactComponent };